export const chartTheme = {
  colors: {
    primary: "#3f90f4",
    secondary: "#1a2b7f",
    accent: "#d5e5f4",
    grid: "#e9e9e9",
    text: "#424242",
    textSecondary: "#4e4e4e",
    background: "#fff",
    border: "#e9e9e9",
  },
  font: {
    family: "Maven Pro",
    sizes: {
      small: 12,
      base: 14,
      medium: 16,
      large: 20,
      xlarge: 24,
    },
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  borderRadius: {
    card: "24px",
    tooltip: "8px",
    button: "8px",
  },
  shadows: {
    card: "rgba(142, 142, 142, 0.2) 0px 1px 3px 0px, rgba(243, 243, 243, 0.14) 0px 1px 1px 0px, rgba(204, 204, 204, 0.12) 0px 2px 1px -1px",
  },
  orderStatusColors: {
    "1": "#3f90f4", // Incoming - Primary blue
    "2": "#1a2b7f", // Packing - Dark blue
    "3": "#4CAF50", // Ready For Admin - Green
    "4": "#FF9800", // Out For Delivery - Orange
    "5": "#2e7d32", // Delivered - Success green
    "6": "#9C27B0", // Pickup Tasks - Purple
  },
};
